import {INewsletter} from '../interfaces/newsletter.interface';
import {INewsletterListResponse} from '../interfaces/newsletter-list-response';
import {Injectable} from '@angular/core';
import {firstValueFrom} from 'rxjs';
import {HttpServiceBase} from '../../../core/services/http-service-base';

@Injectable()
export class NewsHttpService extends HttpServiceBase{

    private newsletters: Map<number, INewsletter[]> = new Map<number, INewsletter[]>();


    async getList(userId: number): Promise<INewsletterListResponse> {
        try {
            const response = await firstValueFrom(
                this.httpClient.get<INewsletterListResponse>(`${this.serverAddress}/v1/users/${userId}/newsletters`, {
                    observe: 'body'
                })
            );
            this.newsletters[userId] = response.newsletters;
            return response;
        } catch (error) {
            throw error;
        }
    }

    async get(userId: number, newsletterId: number): Promise<INewsletter | null> {
        let newsletters: INewsletter[];
        try {
            newsletters = this.newsletters[userId];
            if (!newsletters) {
                await this.getList(userId);
            }
            newsletters = this.newsletters[userId];
            if (!newsletters) {
                return null;
            }
            const result = newsletters.find((newsletter: INewsletter) => {
                return newsletter.id === newsletterId;
            });
            return result ? result : null;
        } catch (error) {
            throw error;
        }
    }

}
